import React from 'react';

import FullLogo from 'assets/images/logos/FullLogo.png';

import { Link, useNavigate, useLocation } from 'react-router-dom';

import Google from 'assets/images/profile/google.svg';

import { supabase } from 'utils/supabaseClient';
import ROUTES from 'utils/routes.js';
import { buildAppUrl } from 'utils/appUrl';

function ForgotPass() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const emailInput = React.useRef(null);

    const [errorMessage, setErrorMessage] = React.useState("");
    const [error, setError] = React.useState(false);

    const [completed, setCompleted] = React.useState(false);

    const [loading, setLoading] = React.useState(false);

    const sendResetEmail = () => {
        if (loading) {
            console.warn("Password reset already in progress.");
            return;
        }

        const email = emailInput?.current?.value || '';
        if (!email.trim()) {
            setErrorMessage("Please enter your email address.");
            setError(true);
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email.trim())) {
            setErrorMessage("Please enter a valid email address.");
            setError(true);
            return;
        }

        setLoading(true);
        setError(false);
        setCompleted(false);
        console.log("Sending password reset email...");

        supabase.auth.resetPasswordForEmail(email, {
            redirectTo: buildAppUrl(ROUTES.UPDATE_PASSWORD)
        }).then(({ error }) => {
            if (error) {
                console.error("Error sending password reset email:", error);
                setErrorMessage(error.message || "An error occurred.");
                setError(true);
            } else {
                console.log("Password reset email sent successfully.");
                setCompleted(true);
            }
        }).catch((err) => {
            console.error("Unexpected error during password reset:", err);
            setErrorMessage("An unexpected error occurred.");
            setError(true);
        }).finally(() => setLoading(false));
    };

    return (
        <div className="flex flex-col items-center h-screen min-h-fit gap-4 bg-background  px-4 break-small:px-20 break-big:px-40" style={{ background: 'linear-gradient(to bottom, var(--background) 0%, var(--background) 15%, var(--primary) 650%)' }}>
            <nav className="w-full flex items-center justify-between py-5 z-10" >
                <Link to={ROUTES.LANDING}><img src={FullLogo} alt="Kodeo Logo" className="h-6 w-auto" /></Link>
                <div className="flex gap-4 items-center">
                    <Link to={ROUTES.SIGNUP} className="bg-background-light text-white font-bold px-6 py-2 rounded-2xl shadow-md hover:bg-background transition-all duration-500 text-lg border-2 border-primary">SIGN UP</Link>
                </div>
            </nav>
            <div className="gap-4 max-w-[480px] flex-grow select-none flex flex-col -mt-32 items-center justify-center w-full sm:w-[400px] break-big:w-[450px]">
                <h1 className="text-white text-3xl md:text-3xl font-bold mb-5">
                    Forgot your password?
                </h1>
                <form method='post' action='#' onSubmit={(e) => e.preventDefault()} className='relative w-full flex flex-col bg-background-light text-white py-3 rounded-3xl shadow-md text-lg border-2 border-border transition-colors duration-500 ease' style={{ borderColor: error ? 'var(--warning)' : (completed ? 'var(--accent)' : 'var(--border)') }}>
                    <div className='absolute left-0 right-0 bottom-full text-white border-warning-dark border-2 text-lg font-bold mb-2 bg-warning py-2 px-2 text-center rounded-xl transition-opacity duration-500 ease' style={{ opacity: error ? 1 : 0 }}>{errorMessage}</div>
                    <div className='absolute left-0 right-0 bottom-full text-white border-accent-dark border-2 text-lg font-bold mb-2 bg-accent py-2 px-2 text-center rounded-xl transition-opacity duration-500 ease' style={{ opacity: completed ? 1 : 0 }}>Please check your email for the reset link.</div>
                    <input ref={emailInput} className='bg-transparent outline-none px-6 py-2 border-border transition-colors duration-500 ease _noAutofill'
                        style={{ borderColor: error ? 'var(--warning)' : (completed ? 'var(--accent)' : 'var(--border)') }}
                        type='email'
                        name='email'
                        autoComplete='email'
                        onChange={() => setError(false)}
                        onKeyDown={(e => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                if (emailInput.current?.value?.length > 0) {
                                    sendResetEmail();
                                }
                                else {
                                    emailInput.current?.focus();
                                }
                            } else if (e.key === 'Escape') {
                                e.preventDefault();
                                setError(false);
                            }
                        })}
                        placeholder='Email Address' />
                </form>
                <button onClick={sendResetEmail} className='bg-primary text-background font-bold px-8 w-full py-4 rounded-3xl shadow-sm shadow-primary text-2xl text-center border-2 border-primary flex items-center justify-center' disabled={loading}>
                    {loading ? (
                        <svg className="animate-spin h-6 w-6 mr-2 text-background" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                        </svg>
                    ) : null}
                    {loading ? "Sending..." : "Send Reset Email"}
                </button>
            </div>
        </div >
    );
}

export default ForgotPass;
